import React from 'react';
import { DeleteBotDialog } from '@/components/dashboard/DeleteBotDialog';
import { DeployBotDialog } from '@/components/dashboard/DeployBotDialog';
import { PageHeader } from '@/components/my-bots/PageHeader';
import { SearchFilterBar } from '@/components/my-bots/SearchFilterBar';
import { BotList } from '@/components/my-bots/BotList';
import { useBotManagement } from '@/hooks/use-bot-management';
import { TourButton } from '@/components/common/TourButton';

const MyBots = () => {
  const {
    bots,
    isLoading,
    filteredBots,
    searchQuery,
    setSearchQuery,
    activeTab,
    setActiveTab,
    botToDelete,
    setBotToDelete,
    isDeployDialogOpen,
    viewMode,
    setViewMode,
    deleteBot,
    handleViewDetails,
    handleToggleStatus,
    handleDeleteClick,
    handleDeleteConfirm,
    handleOpenDeployDialog,
    handleCloseDeployDialog
  } = useBotManagement();

  return (
    <div className="space-y-8 pb-10">
      <div data-tour="bots-header" className="flex items-center gap-2">
        <PageHeader onOpenDeployDialog={handleOpenDeployDialog} />
        <TourButton pageId="my-bots" />
      </div>
      
      <div data-tour="bot-filters">
        <SearchFilterBar 
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          viewMode={viewMode}
          setViewMode={setViewMode}
        />
      </div>
      
      <div data-tour="deploy-bot">
        <BotList
          bots={bots}
          filteredBots={filteredBots}
          isLoading={isLoading}
          searchQuery={searchQuery}
          viewMode={viewMode}
          onViewDetails={handleViewDetails}
          onToggleStatus={handleToggleStatus}
          onDeleteClick={handleDeleteClick}
          onOpenDeployDialog={handleOpenDeployDialog}
        />
      </div>
      
      <DeleteBotDialog
        bot={botToDelete}
        isOpen={!!botToDelete}
        isLoading={deleteBot.isPending}
        onClose={() => setBotToDelete(null)}
        onConfirm={handleDeleteConfirm}
      />

      <DeployBotDialog
        isOpen={isDeployDialogOpen}
        onClose={handleCloseDeployDialog}
      />
    </div>
  );
};

export default MyBots;
